/* Pocketry cart expiry guard (owner 2026-10-18: temporary photo storage).
 * Unordered photos are deleted automatically 30 days after upload, so every portrait cart line carries a
 * signed "_pocketry_expires" date (YYYY-MM-DD, its last valid day). Lines past that date are removed from the
 * cart before checkout, and the shopper is told to upload their photo again. Lines without the property
 * (older carts, ordinary products) are never touched.
 */
(function () {
  'use strict';
  var KEY = 'pocketry_cart_expired';
  function notice(count) {
    var bar = document.createElement('div');
    bar.setAttribute('role', 'status');
    bar.style.cssText = 'position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,560px);' +
      'background:#62063a;color:#fff;font:500 15px/1.4 Poppins,system-ui,sans-serif;padding:14px 18px;border-radius:12px;' +
      'box-shadow:0 8px 24px rgba(0,0,0,.25);text-align:center';
    bar.textContent = 'For your privacy we only keep photos for 30 days, so ' +
      (count === 1 ? 'a portrait was' : count + ' portraits were') +
      ' removed from your cart. Please upload your photo again to continue.';
    document.body.appendChild(bar);
    setTimeout(function () { bar.remove(); }, 12000);
  }
  try {
    var shown = sessionStorage.getItem(KEY);
    if (shown) { sessionStorage.removeItem(KEY); document.addEventListener('DOMContentLoaded', function () { notice(Number(shown) || 1); }); }
  } catch (e) { /* storage blocked: no notice */ }
  var today = new Date().toISOString().slice(0, 10);
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var stale = (cart.items || []).filter(function (item) {
        var expires = item.properties && item.properties._pocketry_expires;
        return typeof expires === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(expires) && expires < today;
      });
      if (!stale.length) return;
      var updates = {};
      stale.forEach(function (item) { updates[item.key] = 0; });
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        try { sessionStorage.setItem(KEY, String(stale.length)); } catch (e) { /* no notice */ }
        location.reload();
      });
    })
    .catch(function () { /* never block the page */ });
})();
